export class TimestampListener {
    public static bindLanguageChanged(onChange: (event: Event) => void): void {
        document.addEventListener("languageChanged", onChange);
    }

    public static bindViewportChange(onChange: () => void): void {
        globalThis.addEventListener("resize", onChange, { passive: true });
        globalThis.addEventListener("orientationchange", onChange, { passive: true });
    }

    public static bindMediaQueryChange(mediaQueryList: MediaQueryList, onChange: () => void): void {
        if (typeof mediaQueryList.addEventListener === "function") {
            mediaQueryList.addEventListener("change", onChange);
            return;
        }

        mediaQueryList.onchange = () => onChange();
        if (mediaQueryList.matches) {
            onChange();
        }
    }
}
